module.exports = __webpack_public_path__ + "media/images/ohap_ui folder_plus_outline_on-8556e099bd0dcd7b1808b8c25dc73cf5.png";